import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Row, Table } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import Pagination from '../../Pagination';
import './HrDashboard.css';
import { MdShare } from 'react-icons/md';
import Swal from 'sweetalert2';

const PostedJobs = () => {

  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const userName = location.state?.userName;
  const userEmail = location.state?.userEmail;
  const [jobs, setJobs] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(6);
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState(' ');
  const [loading, setLoading] = useState(true);

  const fetchJobs = async () => {
    setLoading(true);
    try {
      const params = {
        userEmail: userEmail,
        page: page,
        size: pageSize,
        sortBy: sortedColumn,
        sortOrder: sortOrder,
      };

      const response = await axios.get(`${BASE_API_URL}/getRegularJobsByAllHrsInCompany`, { params });
      setJobs(response.data.content);
      setTotalPages(response.data.totalPages);
      setLoading(false);
    } catch (error) {
    }
  };

  const handleSort = (column) => {
    let order = 'asc';
    if (sortedColumn === column) {
      order = sortOrder === 'asc' ? 'desc' : 'asc';
    }
    setSortedColumn(column);
    setSortOrder(order);
  };

  const fetchJobBysearch = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_API_URL}/searchJobsByCompany`, {
        params: {
          search, userEmail, page, pageSize, sortBy: sortedColumn,
          sortOrder: sortOrder,
        }
      });
      setJobs(response.data.content);
      setTotalPages(response.data.totalPages);
      setLoading(false);
    } catch (error) {
      alert("Error searching for jobs. Please try again later.");
    }
  }

  useEffect(() => {
    if (search) {
      fetchJobBysearch();
    } else {
      fetchJobs();
    }
  }, [userEmail, page, pageSize, sortedColumn, sortOrder, search]);


  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const [selectedJobSummary, setSelectedJobSummary] = useState(null);
  const handleViewSummary = (summary) => {
    setSelectedJobSummary(summary);
  };

  const handleCloseModal = () => {
    setSelectedJobSummary(null);
  };

  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPage(0);
    setPageSize(size);
  };

  const handlePageClick = (data) => {
    const selectedPage = data.selected;
    setPage(selectedPage);
  };

  const isLastPage = page === totalPages - 1;
  const isPageSizeDisabled = isLastPage;
  const handleShare = (job) => {
    const slug = `${job.jobId}-${job.jobTitle
      .replace(/\s+/g, "-")
      .toLowerCase()}-${job.companyName.replace(/\s+/g, "-").toLowerCase()}`;
    const shareUrl = `${window.location.origin}/browse-jobs/job-details/${slug}`;
    //const shareUrl = `${window.location.origin}/job-details/${jobId}`; // Or however your public job link is structured

    if (navigator.share) {
      navigator.share({
        title: 'Job Opportunity',
        text: 'Check out this job!',
        url: shareUrl,
      })
        .then(() => console.log('Job shared successfully'))
        .catch((error) => console.error('Error sharing', error));
    } else {
      navigator.clipboard.writeText(shareUrl)
        .then(() => {
          Swal.fire({
            title: 'Link Copied!',
            text: 'Job link copied to clipboard. You can share it now.',
            icon: 'success',
            timer: 2000,
            showConfirmButton: false
          });
        })
        .catch(() => {
          Swal.fire({
            title: 'Error',
            text: 'Could not copy link. Please try again.',
            icon: 'error'
          });
        });
    }
  };
  return (
    <div >
      <Row>
        <Col md={4}>
          <h2>
            {!loading && jobs.length === 0 ? (
              <div style={{ color: 'red', textAlign: 'center' }}>
                {search
                  ? `There is no job `
                  : 'No jobs to show'}
              </div>
            ) : (
              <div className='text-start'></div>
            )}
          </h2>
        </Col>

        <Col md={3} className="d-flex align-items-left">
          {/* Search Bar */}
          <div className="search-bar" style={{ flex: 1 }}>
            <input
              style={{
                borderColor: '#6c5b7b',
                borderRadius: '6px',
                height: '40px', // Match the height of the select
                width: '70%', // Full width
                padding: '0 10px', // Add horizontal padding for text
                marginRight: '20px', marginBottom: '10px'
              }}
              type="text"
              name="search"
              placeholder="Search"
              value={search}
              onChange={handleSearchChange}
            />
          </div>
        </Col>
      </Row>

      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <div className="spinner-bubble spinner-bubble-primary m-5" />
          <span>Loading...</span>
        </div>
      ) : jobs.length > 0 ? (
        <div>
          <Card body>
            {/* <Card.Title>Light hoverable Table</Card.Title>

            <p>
              Add <code>.table-hover</code> to enable a hover state on table rows within a{" "}
              <code>&lt;tbody&gt;</code>.
            </p> */}
            <div className="table-details-list table-wrapper">
              <Table hover responsive >
                <thead>
                  <tr>
                    <th scope="col">Hr Name</th>
                    <th scope="col">Company Name</th>

                    <th
                      scope="col"
                      onClick={() => handleSort('jobTitle')}
                      style={{ cursor: 'pointer' }}
                    >
                      Job Title{' '}
                      <span>
                        <span
                          style={{
                            color: sortedColumn === 'jobTitle' && sortOrder === 'asc' ? 'black' : 'gray',
                          }}
                        >
                          ↑
                        </span>{' '}
                        <span
                          style={{
                            color: sortedColumn === 'jobTitle' && sortOrder === 'desc' ? 'black' : 'gray',
                          }}
                        >
                          ↓
                        </span>
                      </span>
                    </th>

                    <th
                      scope="col"
                      onClick={() => handleSort('jobType')}
                      style={{ cursor: 'pointer' }}
                    >
                      Job Type{' '}
                      <span>
                        <span
                          style={{
                            color: sortedColumn === 'jobType' && sortOrder === 'asc' ? 'black' : 'gray',
                          }}
                        >
                          ↑
                        </span>{' '}
                        <span
                          style={{
                            color: sortedColumn === 'jobType' && sortOrder === 'desc' ? 'black' : 'gray',
                          }}
                        >
                          ↓
                        </span>
                      </span>
                    </th>

                    <th
                      scope="col"
                      onClick={() => handleSort('skills')}
                      style={{ cursor: 'pointer' }}
                    >
                      Skills{' '}
                      <span>
                        <span
                          style={{
                            color: sortedColumn === 'skills' && sortOrder === 'asc' ? 'black' : 'gray',
                          }}
                        >
                          ↑
                        </span>{' '}
                        <span
                          style={{
                            color: sortedColumn === 'skills' && sortOrder === 'desc' ? 'black' : 'gray',
                          }}
                        >
                          ↓
                        </span>
                      </span>
                    </th>

                    <th
                      scope="col"
                      onClick={() => handleSort('numberOfPosition')}
                      style={{ cursor: 'pointer' }}
                    >
                      Vacancy{' '}
                      <span>
                        <span
                          style={{
                            color: sortedColumn === 'numberOfPosition' && sortOrder === 'asc' ? 'black' : 'gray',
                          }}
                        >
                          ↑
                        </span>{' '}
                        <span
                          style={{
                            color: sortedColumn === 'numberOfPosition' && sortOrder === 'desc' ? 'black' : 'gray',
                          }}
                        >
                          ↓
                        </span>
                      </span>
                    </th>

                    <th scope="col">Job Description</th>

                    <th
                      scope="col"
                      onClick={() => handleSort('applicationDeadline')}
                      style={{ cursor: 'pointer' }}
                    >
                      Application Deadline{' '}
                      <span>
                        <span
                          style={{
                            color: sortedColumn === 'applicationDeadline' && sortOrder === 'asc' ? 'black' : 'gray',
                          }}
                        >
                          ↑
                        </span>{' '}
                        <span
                          style={{
                            color: sortedColumn === 'applicationDeadline' && sortOrder === 'desc' ? 'black' : 'gray',
                          }}
                        >
                          ↓
                        </span>
                      </span>
                    </th>
                    <th>
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {jobs.map(job => (
                    <tr key={job.jobId}>
                      <td>{job.userName}</td>
                      <td>{job.companyName}</td>
                      <td><a onClick={() => handleViewSummary(job.jobsummary)}>{job.jobTitle}</a></td>
                      <td>{job.jobType}</td>
                      <td>{job.skills}</td>
                      <td>{job.numberOfPosition}</td>
                      <td><Button variant="secondary" className='description btn-rounded' onClick={() => handleViewSummary(job.jobsummary)}>Summary</Button></td>
                      <td>{job.applicationDeadline}</td>
                      {/* <td>
                        {/* New Share button 
                        <span
                          className="cursor-pointer text-success me-2 update" onClick={() => handleShare(job)}>
                          <MdShare size={18} className="text-success" />
                        </span>
                      </td> */}
                      <td>
                        <Button
                          variant='success' onClick={() => handleShare(job)}>
                          {/* <MdShare size={18}/> Share */} Share
                        </Button></td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            {/* {selectedJobSummary && (
              <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Job Summary</h5>
                    </div>
                    <div className="modal-body">
                      <pre className="job-details-text" style={{ color: 'black' }}>{selectedJobSummary}</pre>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )} */}

            <Pagination
              page={page}
              pageSize={pageSize}
              totalPages={totalPages}
              handlePageSizeChange={handlePageSizeChange}
              isPageSizeDisabled={isPageSizeDisabled}
              handlePageClick={handlePageClick}
            />
          </Card>


        </div>
      ) : (
        // <p>No jobs available.</p>
        <section> </section>
      )}
      {selectedJobSummary && (
        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
          <div className="modal-dialog" role="document" >  {/*style={{ minWidth: '300px', maxWidth: '80%' }} */}
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Job Summary</h5>
              </div>
              <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                <pre className="job-details-text">{selectedJobSummary}</pre>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      handleCloseModal();
                    }
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
export default PostedJobs;
